/**
 * ============================================================================
 * EXPERIMENT: Calendly Integration (ab_calendly)
 * PR: #TODO_AFTER_PR_CREATION_ab_calendly
 *
 * API functions for Calendly REST API v2.
 * Temporary code — will be REMOVED when the experiment concludes.
 *
 * Find all experiment code: grep -r "ab_calendly" src/
 * ============================================================================
 */

import { getAccessToken } from './AB_calendly-auth';
import type {
    CalendlyListResponse,
    CalendlyResourceResponse,
    CalendlyUser,
    ScheduledEvent,
} from './AB_calendly-types';

const CALENDLY_API_BASE = 'https://api.calendly.com';

async function calendlyFetch<T>(path: string, params?: Record<string, string>): Promise<T> {
    const token = getAccessToken();
    if (!token) throw new Error('Not connected to Calendly');

    const url = new URL(`${CALENDLY_API_BASE}${path}`);
    if (params) {
        Object.entries(params).forEach(([key, value]) => url.searchParams.set(key, value));
    }

    const response = await fetch(url.toString(), {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
    });

    if (!response.ok) {
        throw new Error(`Calendly API error: ${response.status}`);
    }

    return response.json() as Promise<T>;
}

export async function fetchCurrentUser(): Promise<CalendlyUser> {
    const data = await calendlyFetch<CalendlyResourceResponse<CalendlyUser>>('/users/me');
    return data.resource;
}

export async function fetchScheduledEvents(
    userUri: string,
): Promise<CalendlyListResponse<ScheduledEvent>> {
    return calendlyFetch<CalendlyListResponse<ScheduledEvent>>('/scheduled_events', {
        user: userUri,
        min_start_time: new Date().toISOString(),
        status: 'active',
        sort: 'start_time:asc',
        count: '20',
    });
}
